export const useHeaderTabsCssClasses = ({ isActive, } = {}) => {
    const headerTabItem = ['header-tab-item'];
    if (isActive) {
        headerTabItem.push('header-tab-item--active');
    }
    return {
        headerTabItem: headerTabItem.join(' '),
    };
};
//# sourceMappingURL=useHeaderTabsCssClasses.js.map